// extracted by mini-css-extract-plugin
export var core = "DVert-module--core--783c2";